export default __webpack_public_path__ + "static/stars-05c6a8ca0c9f2780481aa196d7f16202.png";